import { WealthPage } from '../components/pages'

export default WealthPage
